<div class="row mb-2" style="margin-top:65px">
  <div class="col-12">
    <a [routerLink]="'/hourglass/tools'">
      <i class="fas fa-fw fa-lock me-2"></i>Admin Tools<i class="fas fa-fw fa-chevron-right mx-2"></i>
    </a>
    <i class="fas fa-fw fa-dollar me-2"></i>Billing Review Tool
  </div>
</div>
<div class="row mb-2">
  <div class="col-12">
    <div style="height: 130px; overflow-y: auto; border: 1px solid #ccc; background: #f4f4f4; padding: 8px; font-family: monospace;">
      <div *ngFor="let log of activityLog" [style.color]="log.success ? 'green' : 'red'">
        <strong>{{ log.timestamp }}</strong>: {{ log.message }}
      </div>
    </div>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="grid_sizer" style="height:70vh">
      <ag-grid-angular class="ag-theme-alpine"
                       style="width: 100%; height: 100%;"
                       [rowData]="rowData"
                       [columnDefs]="columnDefs"
                       [defaultColDef]="defaultColDef"
                       [pagination]="true"
                       [paginationPageSize]="100"
                       (gridReady)="onGridReady($event)"
                       (cellValueChanged)="onCellValueChanged($event)">
      </ag-grid-angular>
    </div>
  </div>
</div>







